// extracted by mini-css-extract-plugin
export default {"compareTableWrapper":"styles_compareTableWrapper__fl9KM"};